










































import Vue from 'vue';
import validate from '@/utils/validate';
import { Component, Prop } from 'vue-property-decorator';
import { getHistoryPage, addStudent, getQrcode } from '@/api/educational';
import { TAddStudentForm } from '@/types/views/educational';
import { TRules } from '@/types/utils';
@Component({})
export default class Add extends Vue {
  @Prop({
    type: Function,
    default() {
      return function() {};
    },
    required: true
  })
  reload!: Function;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getStudentQrcode!: Function;
  @Prop({
    type: String,
    required: false
  })
  qrcodeUrl!: String;
  private dialogVisible = false;
  private xlsAttr = {};
  private form: TAddStudentForm = {
    phone: '',
    realname: '',
    age: '',
    address: ''
  };
  private rules: TRules = {
    phone: [
      {
        required: true,
        validator: validate.validatorPhone_rule,
        trigger: 'blur'
      }
    ]
  };
  /**
   * @description: 学员录入
   */
  private onSubmit() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        this.addStudent()
        this.reload()
      } else {
        this.$message.warning('请填写完整');
        return false;
      }
    });
  }
  private async addStudent() {
    try {
      const data = await addStudent({
        courseId: parseInt(this.$route.params.id),
        orgUserStr: JSON.stringify(this.form)
      });
      // console.log(data)
      if (data.code === '000001') {
        this.dialogVisible = false;
        this.$message.success('学员录入成功');
        this.reload();
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  /**
   * @description: 设置Xls 额外参数
   */
  private setXlsAttr() {
    this.xlsAttr = {
      courseId: this.$route.params.id
    };
  }
  /**
   * @description: Xls 成功回调
   * @param {Object} response 请求返回值
   * @param {File} file file文件
   * @param {Array} fileList 文件列表
   */
  private handleSuccess(response: any, file: any, fileList: any[]) {
    if (response.code === '000001') {
      this.$message.success(response.data || '操作成功');
      this.reload();
    } else {
      fileList.pop();
      this.$message.error('文件格式有问题，请调整后重新上传');
    }
  }
  /**
   * @description: Xls 错误回调
   * @param {Object} err 错误值
   * @param {File} file file文件
   * @param {Array} fileList 文件列表
   */
  private handleError(err: any, file: any, fileList: any[]) {
    this.$message.error('文件上传失败，请重新上传');
    /**
     * @description: 获取导入历史
     */
  }
  private async getUploadHistory() {
    try {
      let res = await getHistoryPage({
        currentPage: 1,
        pageSize: 100
      });
      return res;
    } catch (err) {
      this.$message.error(err.message);
    }
  }
   async createQrcode() {
    await this.getStudentQrcode();
    (this.$refs.qrcode as any).dialogVisible = true;
  }
  /**
   * @description: 批量导入
   */
  onExport() {
    this.setXlsAttr();
    (this.$refs.xls as any).dialogVisible = true;
  }
}
